import { ArrowUturnUpIcon } from '@heroicons/react/20/solid';
import { CompletePreBookingFragment, useConvertPreBookingMutation } from 'drycut-graphql';
import { Button, Stack } from 'ui-components';
import ConvertConfirmation from './ConvertConfirmation';
import { useBoolean } from 'usehooks-ts';

type Props = {
  preBooking: CompletePreBookingFragment;
};

export function ConvertPreBookingButton({ preBooking }: Props): React.ReactElement {
  const [convertPreBooking, { loading }] = useConvertPreBookingMutation({
    variables: { input: { preBookingId: preBooking.id } },
  });
  const { value: confirmOpen, toggle: toggleConfirmOpen } = useBoolean(false);

  const handleConfirm = async () => {
    toggleConfirmOpen();
    await convertPreBooking();
  };

  return (
    <>
      <Button
        size="small"
        textClassName="px-0 text-nowrap text-ellipsis overflow-hidden max-w-32"
        loading={loading}
        onClick={toggleConfirmOpen}
      >
        {!loading && (
          <Stack direction="row" gap={1}>
            <ArrowUturnUpIcon className="w-4 h-4" />
            <span className="sm:hidden xl:flex">Warteschlange</span>
          </Stack>
        )}
      </Button>

      <ConvertConfirmation
        open={confirmOpen}
        onClose={toggleConfirmOpen}
        onConfirm={handleConfirm}
      />
    </>
  );
}
